import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import moment from "jalali-moment";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";

import utils from "../../components/toastify/toastify";
import DatePicker from "react-modern-calendar-datepicker";

const EditProductToUser = (props) => {
  const [
    get_user_details_error,
    get_user_details_loading,
    get_user_details_data,
    get_user_details_function,
  ] = useRequest({
    method: "post",
    url: "/get_user_details",
    body: {
      user_id: props.match.params.user_id,
    },
  });

  const [final_product, set_final_product] = useState();
  const [product_data, set_product_data] = useState();

  const [selectedDay, setSelectedDay] = useState(null);

  useEffect(() => {
    if (get_user_details_data) {
      let item = get_user_details_data.data.user_data.products?.find(
        (i) => i.product_id._id === props.match.params.product_id
      );
      set_product_data(item.product_id);
      item.product_id = item.product_id._id;
      set_final_product(item);
      const defaultValue = {
        year: Number(moment(item.creation_date).locale("fa").format("YYYY")),
        month: Number(moment(item.creation_date).locale("fa").format("M")),
        day: Number(moment(item.creation_date).locale("fa").format("D")),
      };
      setSelectedDay(defaultValue);
    }
  }, [get_user_details_data]);

  let history = useHistory();

  const [
    edit_product_user_error,
    edit_product_user_loading,
    edit_product_user_data,
    edit_product_user_function,
  ] = useRequest({
    method: "post",
    isFunction: true,
    url: "/edit_product_user",
    body: {
      user_id: props.match.params.user_id,
      product_id: final_product?.product_id,
      product: final_product,
    },
  });

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">ویرایش محصول جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">ویرایش محصول جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                {/* <input
                                  type="text"
                                  style={{
                                    marginBottom: "10px",
                                  }}
                                  class="form-control"
                                  placeholder="نام کاربری"
                                  value={user_name}
                                  onChange={(e) =>
                                    set_user_name(e.target.value)
                                  }
                                /> */}
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  marginRight: "2rem",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{ marginLeft: "1rem" }}>
                                  تاریخ ایجاد :
                                </div>
                                <DatePicker
                                  value={selectedDay}
                                  onChange={(selectedDay) => {
                                    set_final_product((i) => ({
                                      ...i,
                                      creation_date: moment(
                                        String(
                                          `${selectedDay.year}/${
                                            String(selectedDay.month).length ===
                                            1
                                              ? "0" + selectedDay.month
                                              : selectedDay.month
                                          }/${
                                            String(selectedDay.day).length === 1
                                              ? "0" + selectedDay.day
                                              : selectedDay.day
                                          }`
                                        ),
                                        "jYYYY/jMM/jDD HH:mm"
                                      ).toISOString(),
                                    }));
                                    setSelectedDay(selectedDay);
                                  }}
                                  inputPlaceholder="انتخاب نمایید"
                                  shouldHighlightWeekends
                                  locale="fa" // add this
                                />
                              </div>
                              <fieldset
                                class="form-group"
                                style={{ marginTop: "1rem" }}
                              ></fieldset>
                              {product_data &&
                              product_data.type === "courses" ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <span style={{ marginLeft: "10px" }}>
                                      پرداخت کامل :{" "}
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={final_product.payment}
                                      onChange={(e) =>
                                        set_final_product((i) => ({
                                          ...i,
                                          payment: e.target.checked,
                                        }))
                                      }
                                    />
                                  </div>
                                  {!final_product.payment ? (
                                    <>
                                      {product_data.terms.map((i) => (
                                        <div style={{ marginBottom: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={
                                                final_product.term_ids.find(
                                                  (_i) =>
                                                    _i.term_id === i._id &&
                                                    _i.payment
                                                )
                                                  ? true
                                                  : false
                                              }
                                              style={{ marginLeft: "5px" }}
                                              onChange={(e) => {
                                                set_final_product((item) => ({
                                                  ...item,
                                                  term_ids: e.target.checked
                                                    ? item.term_ids.find(
                                                        (_i) =>
                                                          _i.term_id === i._id
                                                      )
                                                      ? [
                                                          {
                                                            term_id: i._id,
                                                            payment: true,
                                                            support_payment:
                                                              item.term_ids.find(
                                                                (_i) =>
                                                                  _i.term_id ===
                                                                  i._id
                                                              )
                                                                ? item.term_ids.find(
                                                                    (_i) =>
                                                                      _i.term_id ===
                                                                      i._id
                                                                  )
                                                                    .support_payment
                                                                : final_product.support_all_payment,
                                                          },
                                                          ...item.term_ids.filter(
                                                            (_i) =>
                                                              _i.term_id !==
                                                              i._id
                                                          ),
                                                        ]
                                                      : [
                                                          ...item.term_ids,
                                                          {
                                                            term_id: i._id,
                                                            payment: true,
                                                            support_payment:
                                                              final_product.support_all_payment,
                                                          },
                                                        ]
                                                    : item.term_ids.filter(
                                                        (_i) =>
                                                          _i.term_id !== i._id
                                                      ),
                                                }));
                                                set_product_data(product_data);
                                              }}
                                            />
                                            {i.title}
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  ) : null}
                                  <div style={{ marginTop: "10px" }}>
                                    <span style={{ marginLeft: "10px" }}>
                                      پشتیبانی کامل :{" "}
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={
                                        final_product.support_all_payment
                                      }
                                      onChange={(e) =>
                                        set_final_product((i) => ({
                                          ...i,
                                          support_all_payment: e.target.checked,
                                        }))
                                      }
                                    />
                                  </div>
                                  {!final_product.support_all_payment ? (
                                    <>
                                      {product_data.terms.map((i) => (
                                        <div style={{ marginBottom: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={
                                                final_product.term_ids.find(
                                                  (_i) =>
                                                    _i.term_id === i._id &&
                                                    _i.support_payment
                                                )
                                                  ? true
                                                  : false
                                              }
                                              style={{ marginLeft: "5px" }}
                                              onChange={(e) => {
                                                set_final_product((item) => ({
                                                  ...item,
                                                  term_ids: e.target.checked
                                                    ? item.term_ids.find(
                                                        (_i) =>
                                                          _i.term_id === i._id
                                                      )
                                                      ? [
                                                          {
                                                            term_id: i._id,
                                                            payment:
                                                              item.term_ids.find(
                                                                (_i) =>
                                                                  _i.term_id ===
                                                                  i._id
                                                              )
                                                                ? item.term_ids.find(
                                                                    (_i) =>
                                                                      _i.term_id ===
                                                                      i._id
                                                                  ).payment
                                                                : final_product.payment,
                                                            support_payment: true,
                                                          },
                                                          ...item.term_ids.filter(
                                                            (_i) =>
                                                              _i.term_id !==
                                                              i._id
                                                          ),
                                                        ]
                                                      : [
                                                          ...item.term_ids,
                                                          {
                                                            term_id: i._id,
                                                            payment:
                                                              final_product.payment,
                                                            support_payment: true,
                                                          },
                                                        ]
                                                    : item.term_ids.filter(
                                                        (_i) =>
                                                          _i.term_id !== i._id
                                                      ),
                                                }));
                                                set_product_data(product_data);
                                              }}
                                            />
                                            {i.title}
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  ) : null}
                                </>
                              ) : null}

                              {/* 
                              <input
                                type="number"
                                class="form-control"
                                style={{
                                  marginBottom: "10px",
                                }}
                                placeholder="شماره همراه"
                                value={phone_number}
                                onChange={(e) =>
                                  set_phone_number(e.target.value)
                                }
                              />
                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="نام"
                                value={name}
                                onChange={(e) => set_name(e.target.value)}
                              />
                              <input
                                type="password"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="رمز عبور"
                                value={password}
                                onChange={(e) => set_password(e.target.value)}
                              />
                              <input
                                type="email"
                                class="form-control"
                                placeholder="ایمیل"
                                value={email}
                                onChange={(e) => set_email(e.target.value)}
                              /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  var $white = "#fff";
                  $.blockUI({
                    message:
                      '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

                    // timeout: 2000, //unblock after 2 seconds
                    overlayCSS: {
                      backgroundColor: $white,
                      opacity: 0.8,
                      cursor: "wait",
                    },
                    css: {
                      border: 0,
                      padding: 0,
                      backgroundColor: "transparent",
                    },
                  });
                  edit_product_user_function()
                    .then(() => {
                      history.goBack();
                      $.unblockUI();
                    })
                    .catch(() => {
                      utils.showAlert("خطایی به وجود آمده است", "error");
                      $.unblockUI();
                    });
                }}
                style={{
                  marginTop: "-2rem",
                  marginRight: "25px",
                  width: "fit-content",
                }}
                type="button"
                class="btn btn-success mr-1 mb-1 "
              >
                ویرایش محصول جدید
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { EditProductToUser };
